import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Story from '../components/Story'
import Successstory from '../components/Successstory'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import { Link } from 'react-router-dom'
import Loader from '../components/Loader'
import Slider from 'react-slick';


const Aboutus = () =>{
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [pageData, setPagedata] = useState(null)
  const [essenceWidget, setEssenceWidget] = useState(null)
  const [missionWidget, setMissionWidget] = useState(null)
  const [ourStoryWidget, setOurStoryWidget] = useState(null)
  const [mindBehindWidget, setMindBehindWidget] = useState(null)
  const [caseStudyWidget, setCaseStudyWidget] = useState(null)
  const [ourReachWidget, setOurRechWidget] = useState(null)
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')

  const [essenceData, setEssenceData] = useState([])
  const [missionData, setMissionData] = useState([])
  const [boardData, setBoardData] = useState([])
  const [coreData, setCoreData] = useState([])
  const [story, setStory] = useState([])
  const [caseStudy, setCaseStudy] = useState([])
  const apiUrl = apiBaseUrl+`aboutpage`;



  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setPagedata(res.data.page)
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setEssenceWidget(res.data.essencewidget)
      setMissionWidget(res.data.missionwidget)
      setOurStoryWidget(res.data.storywidget)
      setMindBehindWidget(res.data.mindwidget)
      setCaseStudyWidget(res.data.casestudywidget)
      setOurRechWidget(res.data.ourreachwidget)
      setEssenceData(res.data.parentessencewidget)
      setMissionData(res.data.missionparentwidget)
      setBoardData(res.data.boardmembers)
      setCoreData(res.data.coremembers)
      setStory(res.data.milestone)
      setCaseStudy(res.data.casestudy)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  const milestonesettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],          
  };  

  const casestudysettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],         
  }; 

  return (
    <>
   <Header/>
    { loading && (<Loader />)}

	<section className="section-content-block" id="abouttop">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
              <div className="about-us-intro">
							  <p className="blue">{pageData?.name}</p>
							  <h2 className="heading">{pageData?.heading}</h2>
                <p className='col-lg-offset-2 col-lg-8 col-md-12 col-sm-12 col-xs-12'>{pageData?.short_description}</p>
              </div>                            
          </div> 
        </div>
				
				<div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
            <div className="Products">
              {pageData?.image && (
                <img src={`${siteUrl}${pageData?.image}`} alt={pageData?.name} />
              )}
            </div>                            
          </div> 
        </div>
      </div> 
  </section>

  <div id="essence" className="container vertical-gap"><hr /></div>

  <section className="section-content-block wow fadeInDown" data-wow-duration="1s">

    <div className="container wow fadeIn">
        
      <div className="row">
          <div className="col-md-offset-2 col-md-8 col-sm-12 text-center about-us-intro">    
              <p className="blue">{essenceWidget?.name}</p>
              <p className="our-experience">{essenceWidget?.heading}</p>
              <div className="about-us-intro col-lg-offset-1 col-lg-10 col-sm-12">
                {essenceWidget?.description}
              </div>                            
          </div>
      </div>

      <div className="row text-center margin-top-32 solar-advantage">
        <ul>
            {essenceData.map((item, index) => {
              return (          
                <li className="" key={index}> 
                    <div className="highlight-box">
                      <div className="icon-box"> 
                        <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                      </div>
                      <p className="heading">{item?.heading}</p>
                      <p>{item?.description}</p>
                    </div>
                </li>
              );
          })}
      </ul>
      </div>

    </div>       
  </section>    

  <div id="vision" className="container vertical-gap"><hr /></div>

  <section className="section-content-block">
    <div className="container">
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                  <p className="blue">{missionWidget?.name}</p>
                  <h2 className="heading">{missionWidget?.heading}</h2>
                  <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{missionWidget?.description}</p>
                </div>                            
            </div> 
  
        </div>

        <div className="row">
            {missionData.map((item, index) => {
              return (            
                <div key={index} className="col-lg-6 col-md-6 col-sm-12 text-center">                       
                    <div className="Products">
                      <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                      <h4 className="heading1">{item?.name}: {item?.heading}</h4>
                      <p>{item?.description}</p>
                    </div>                            
                </div> 
              );
          })}
        </div>
    </div> 
  </section>
	
	<div id="story" className="container vertical-gap"><hr /></div>

  <section className="section-content-block pb-170">
      <div className="container">
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                <div className="about-us-intro">
                  <p className="blue">{ourStoryWidget?.name}</p>
                  <h2 className="heading">{ourStoryWidget?.heading}</h2>
                  <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{ourStoryWidget?.description}</p>
                </div>                            
            </div> 
        </div>
      {(story.length > 0) && (
        <div className="row">
          <div className="story-carousel clients col-sm-12">
            <Slider {...milestonesettings}>
              {story.map((item, index)=>{
                return(
                  <Story
                    key={index}
                    prm={{
                      name: item?.name,
                      description: item?.description
                    }}
                  />
                )
              })}

            </Slider>
          </div>
        </div>
      )}
      </div> 
  </section>

  <section className="mb-100">
    <div className="container">
      <div className="row">
          <img src="/images/storyline.jpg" alt="" /> 
      </div>      
    </div>
  </section>
	

	<div id="minds" className="container vertical-gap" ><hr /></div>  




  <section className="section-content-block minds">
    <div className="container">

      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 text-center minds">                       
          <div className="about-us-intro solution">
						<p className="blue">{mindBehindWidget?.name}</p>
						<h2 className="heading">{mindBehindWidget?.heading}</h2>
            <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{mindBehindWidget?.description}</p>
          </div>                            
        </div> 
      </div>
				
      <div className="row">
        <div className="col-sm-12 text-center">
          <h3>The Board</h3>
        </div>
        {boardData.map((item, index) => {
          return ( 
            <div key={index} className="col-lg-3 col-md-4 col-sm-12">                       
              <div className="Products">
                <img src={`${siteUrl}${item.image}`} alt={item.member_name} /> 
                <h4 className="heading">{item.member_name}</h4>
                <p>{item?.designation}</p>
                <Link 
                to={item?.linkedin} 
                target='_blank'
                className="custom-social-icom"
                ><i className="fa fa-linkedin-square"></i></Link>            
              </div>

            </div>
          )
        })}
      </div>
              
      <div className="row">
        <div className="col-sm-12 text-center">
          <h3>Core personnel</h3>
        </div>

   
        {coreData.map((item, index) => {
          return ( 
            <div key={index} className="col-lg-3 col-md-4 col-sm-12">                       
              <div className="Products">
                <img src={`${siteUrl}${item.image}`} alt={item.member_name} /> 
                <h4 className="heading">{item.member_name}</h4>
                <p>{item?.designation}</p>
                <Link 
                to={item?.linkedin} 
                target='_blank'
                className="custom-social-icom"
                ><i className="fa fa-linkedin-square"></i></Link>            
              </div>

            </div>
          )
        })}



      </div>

    </div> 

  </section>


  <div id="case-study" className="container vertical-gap"><hr/></div>
	
	<section className="section-content-block pb1-170">
    <div className="container">
      <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
              <div className="about-us-intro">
                <p className="blue">{caseStudyWidget?.name}</p>
                <h2 className="heading">{caseStudyWidget?.heading}</h2>
                <p className='col-lg-offset-2 col-lg-8 col-sm-12 success-case-study-desc'>{caseStudyWidget?.description}</p>
              </div>                            
          </div> 
      </div>
				
      {(caseStudy.length > 0) && (
			<div className="row pb-100">
					<div className="casestudies-carousel col-sm-12 owl-carousel">
            <Slider {...casestudysettings}>
            {caseStudy.map((item, index)=>{
              return (
                <Successstory
                  key={index}
                  prm= {{
                    name: item?.name,
                    slug: item?.slug,
                    case_type: item?.case_type,
                    short_description: item?.short_description,
                    image: `${siteUrl}${item?.image}`
                  }}
                />
              )
            })}
            </Slider>
          </div>
      </div> 
      )}  
		</div>
  </section>


	<div id="reach" className="container vertical-gap"><hr /></div>
	
	<section className="section-content-block ">
    <div className="container">
        <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">                       
              <div className="about-us-intro Reach">
                <p className="blue">{ourReachWidget?.name}</p>
                <h2 className="heading">{ourReachWidget?.heading}</h2>
                <p>{ourReachWidget?.description}</p>
              </div>                            
            </div> 
            <div className="col-lg-6 col-md-6 col-sm-12 text-right">
              <img src={`${siteUrl}${ourReachWidget?.image}`} alt={ourReachWidget?.name} />              
            </div>
        </div>
    </div> 
  </section>	


    <Footer/>    
    </>

  )
}

export default Aboutus